import axios from 'axios';
export default class BillingService {
  async initiatePayment(companyId, billingInfo, selectedTierId, selectedPeriod) {
    const response = await axios({
      method: 'POST',
      url: `/subscription/initPayment`,
      withCredentials: true,
      data: {
        billing_info: billingInfo,
        company_id: companyId,
        selected_tier_id: selectedTierId,
        selected_period: selectedPeriod,
      },
    });
    return response.data;
  }
  async saveBillingInfo(companyId, billingInfo) {
    const response = await axios({
      method: 'POST',
      url: `/billing/upsertBillingData`,
      withCredentials: true,
      data: {
        billing_info: billingInfo,
        company_id: companyId,
      },
    });
    return response.data;
  }
  async getAvailableTiers() {
    const response = await axios({
      method: 'get',
      url: `/subscription/tiers`,
    });
    return response.data;
  }

  async cancelSubscription(companyId, reason) {
    const response = await axios({
      method: 'POST',
      url: '/subscription/cancelSubscription',
      withCredentials: true,
      data: {
        company_id: companyId,
        reason,
      },
    });

    return response.data;
  }

  async restartSubscription(companyId) {
    const response = await axios({
      method: 'POST',
      url: '/subscription/renewSubscription',
      withCredentials: true,
      data: {
        company_id: companyId,
      },
    });

    return response.data;
  }
}
